export default {
  COUPLE: 'couple',
  SINGLE: 'single'
}
